// extracted by mini-css-extract-plugin
export default {"introduction":"Introduction_introduction__TgoT-","title":"Introduction_title__YvP6N","description":"Introduction_description__6hy6G"};